export enum ApiStatusCodeVo {
  /**
   * 뷰어 프리뷰 토큰 에러 코드
   */
  ExpiredPreviewViewerToken = -20500,
}
